import { Link } from "react-router-dom";
import { MapPin, Package } from "lucide-react";
import { imageUrl } from "@/lib/api";
import { Stars } from "@/components/Stars";

export function SellerCard({ seller, index = 0 }) {
  return (
    <Link to={`/seller/view/${seller.id}`} data-testid={`seller-card-${seller.id}`}
      className="bg-[#FAF7F2] border border-[#E5DEC9] rounded-2xl overflow-hidden hover:border-[#1A3C2A]/40 hover:shadow-lg transition-all flex flex-col animate-fade-up"
      style={{ animationDelay: `${Math.min(index * 40, 300)}ms` }}>
      <div className="h-24 bg-[#E8E0CF] relative">
        {seller.cover && <img src={imageUrl(seller.cover)} alt="" className="w-full h-full object-cover" loading="lazy" />}
      </div>
      <div className="px-5 pb-5 -mt-8 flex flex-col">
        <div className="w-16 h-16 rounded-2xl border-4 border-[#FAF7F2] bg-white overflow-hidden shadow-sm">
          <img src={imageUrl(seller.logo)} alt={seller.shop_name} className="w-full h-full object-cover" loading="lazy" />
        </div>
        <h3 className="font-display font-bold text-[#1A3C2A] text-base mt-2 leading-tight">{seller.shop_name}</h3>
        <span className="text-xs font-semibold text-[#E07A5F] uppercase tracking-wide mt-0.5">{seller.category}</span>
        <div className="flex items-center gap-1 text-xs text-[#5A626A] mt-1.5">
          <MapPin size={12} /> {seller.area?.split(",")[0]}
          {seller.distance_miles != null && <span className="ml-1">· {seller.distance_miles} mi</span>}
        </div>
        <div className="flex items-center justify-between mt-3">
          <Stars rating={seller.rating} count={seller.review_count} />
          <span className="text-xs text-[#5A626A] flex items-center gap-1"><Package size={12} /> {seller.product_count}</span>
        </div>
      </div>
    </Link>
  );
}
